import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ConsultaRucService = {

    async Get(qs) { return await methods.Get("ConsultaRuc/Get" + useParamsJson(qs)); },
    async GetSync(qs) { return await methods.Get("ConsultaRuc/GetSync" + useParamsJson(qs)); },
    async Post(data) { return await methods.Post("ConsultaRuc/Post", data) },
    async Put(qs, data) { return await methods.Put("ConsultaRuc/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ConsultaRuc/Delete" + useParamsJson(qs)) }
};

export default ConsultaRucService;